// Définition de la langue par défaut
const defaultLanguage = "en";

// Fonction utilitaire pour obtenir la valeur d'un paramètre GET dans l'URL
const getUrlParameter = (name) => new URLSearchParams(window.location.search).get(name);

// Fonction pour déterminer la langue courante
const getCurrentLanguage = () => {
  try{
    const urlLocale = getUrlParameter("defaultLocale");
    const urlForce = getUrlParameter("force");
    if (urlLocale && urlForce && typeof translations !== 'undefined' && translations[urlLocale.toLowerCase()] && "true" == urlForce.toLowerCase()) {      
      return urlLocale.toLowerCase();
    }
  }
  catch(urlParameterForceException){
    console.error("Error while checking defaultLanguage and force in URL", urlParameterForceException);
  }

  try{
    const browserLang = (navigator.language || navigator.userLanguage).slice(0, 2).toLowerCase();
    if (typeof translations !== 'undefined' && translations[browserLang]) {
      return browserLang;
    }
  }
  catch(detectionException){
    console.error("Error while detecting browser language", detectionException);
  }

  try{
    const urlLocale = getUrlParameter("defaultLocale");
    if (urlLocale && typeof translations !== 'undefined' && translations[urlLocale.toLowerCase()]) {
      return urlLocale.toLowerCase();
    }
  }
  catch(urlParameterException){
    console.error("Error while checking defaultLanguage in URL", urlParameterException);
  }
  
  return defaultLanguage;
};

// Fonction qui applique la traduction à un élément en fonction de son type
function localizeElement(el, translation) {
  const tag = el.tagName.toLowerCase();
  if (tag === "img") {
    // Pour les images, on met à jour l'attribut src
    el.src = translation;
    // Optionnel : on peut aussi mettre à jour alt si besoin
    if (translations[getCurrentLanguage()] && translations[getCurrentLanguage()][tag + "-alt"]) {
      el.alt = translations[getCurrentLanguage()][tag + "-alt"];
    }
  }
  if (tag === "link") {
    // Pour les images, on met à jour l'attribut src
    el.href = translation;
  }
  if (tag === "iframe") {
    console.log("localizeElement avant localisation:", el.src, " apres localisation:", translation);
    el.src = translation;
  } else {
    // Pour les autres éléments, on remplace tout le contenu
    el.innerHTML = translation;
  }
}

// Fonction de localisation qui applique les traductions aux éléments de la page
const localizePage = () => {
  const currentLang = getCurrentLanguage();
  document.querySelector("html").setAttribute("lang", currentLang);
  console.log("localizePage", translations, translations[currentLang]);
  document.querySelectorAll('[data-i18n]').forEach(el => {
    const key = el.getAttribute('data-i18n');    
    if (translations[currentLang] && translations[currentLang][key]) {
      localizeElement(el, translations[currentLang][key]);
    } else {
      console.warn(`Traduction manquante pour la clé "${key}" en "${currentLang}"`);
    }
  });
  document.querySelector("html").style.opacity=1;
};

document.addEventListener('DOMContentLoaded', localizePage);

// ======= Population Dynamique des Pays =======
// Nouvelle structure pour les pays par langue
const countriesByLang = {
  en: [
    "Afghanistan","South Africa","Albania","Algeria","Germany","Andorra","Angola",
    "Antigua and Barbuda","Saudi Arabia","Argentina","Armenia","Australia","Austria",
    "Azerbaijan","Bahamas","Bahrain","Bangladesh","Barbados","Belgium","Belize",
    "Benin","Bhutan","Belarus","Myanmar","Bolivia","Bosnia and Herzegovina","Botswana",
    "Brazil","Brunei","Bulgaria","Burkina Faso","Burundi","Cambodia","Cameroon","Canada",
    "Cape Verde","Central African Republic","Chad","Chile","China","Cyprus","Colombia",
    "Comoros","Republic of the Congo","Democratic Republic of the Congo","North Korea",
    "South Korea","Costa Rica","Ivory Coast","Croatia","Cuba","Denmark","Djibouti",
    "Dominica","Egypt","El Salvador","United Arab Emirates","Ecuador","Eritrea","Spain",
    "Estonia","United States","Ethiopia","Fiji","Finland","France","Gabon","Gambia",
    "Georgia","Ghana","Greece","Grenada","Guatemala","Guinea","Guinea-Bissau",
    "Equatorial Guinea","Guyana","Haiti","Honduras","Hungary","India","Indonesia",
    "Iraq","Iran","Ireland","Iceland","Israel","Italy","Jamaica","Japan","Jordan",
    "Kazakhstan","Kenya","Kyrgyzstan","Kiribati","Kuwait","Laos","Lesotho","Latvia",
    "Lebanon","Liberia","Libya","Liechtenstein","Lithuania","Luxembourg",
    "North Macedonia","Madagascar","Malaysia","Malawi","Maldives","Mali","Malta",
    "Marshall Islands","Mauritania","Mauritius","Mexico","Micronesia","Moldova",
    "Monaco","Mongolia","Montenegro","Morocco","Mozambique","Namibia","Nauru","Nepal",
    "Nicaragua","Niger","Nigeria","Norway","New Zealand","Oman","Uganda","Uzbekistan",
    "Pakistan","Palau","Panama","Papua New Guinea","Paraguay","Netherlands","Peru",
    "Philippines","Poland","Portugal","Qatar","Dominican Republic","Romania",
    "United Kingdom","Russia","Rwanda","Saint Kitts and Nevis","Saint Lucia",
    "Saint Vincent and the Grenadines","Solomon Islands","Samoa","Sao Tome and Principe",
    "Senegal","Serbia","Seychelles","Sierra Leone","Singapore","Slovakia","Slovenia",
    "Somalia","Sudan","South Sudan","Sri Lanka","Sweden","Switzerland","Suriname",
    "Eswatini","Syria","Tajikistan","Tanzania","Thailand","Timor-Leste","Togo","Tonga",
    "Trinidad and Tobago","Tunisia","Turkmenistan","Turkey","Tuvalu","Ukraine","Uruguay",
    "Vanuatu","Vatican City","Venezuela","Vietnam","Yemen","Zambia","Zimbabwe"
  ],
  fr: [
    "Afghanistan","Afrique du Sud","Albanie","Algérie","Allemagne","Andorre","Angola",
    "Antigua-et-Barbuda","Arabie saoudite","Argentine","Arménie","Australie","Autriche",
    "Azerbaïdjan","Bahamas","Bahreïn","Bangladesh","Barbade","Belgique","Belize",
    "Bénin","Bhoutan","Biélorussie","Birmanie","Bolivie","Bosnie-Herzégovine",
    "Botswana","Brésil","Brunéi","Bulgarie","Burkina Faso","Burundi","Cambodge",
    "Cameroun","Canada","Cap-Vert","République centrafricaine","Tchad","Chili","Chine",
    "Chypre","Colombie","Comores","République du Congo",
    "République démocratique du Congo","Corée du Nord","Corée du Sud","Costa Rica",
    "Côte d'Ivoire","Croatie","Cuba","Danemark","Djibouti","Dominique","Égypte",
    "Salvador","Émirats arabes unis","Équateur","Érythrée","Espagne","Estonie",
    "États-Unis","Éthiopie","Fidji","Finlande","France","Gabon","Gambie","Géorgie",
    "Ghana","Grèce","Grenade","Guatemala","Guinée","Guinée-Bissau",
    "Guinée équatoriale","Guyana","Haïti","Honduras","Hongrie","Inde","Indonésie",
    "Irak","Iran","Irlande","Islande","Israël","Italie","Jamaïque","Japon","Jordanie",
    "Kazakhstan","Kenya","Kirghizistan","Kiribati","Koweït","Laos","Lesotho","Lettonie",
    "Liban","Libéria","Libye","Liechtenstein","Lituanie","Luxembourg",
    "Macédoine du Nord","Madagascar","Malaisie","Malawi","Maldives","Mali","Malte",
    "Îles Marshall","Mauritanie","Maurice","Mexique","Micronésie","Moldavie","Monaco",
    "Mongolie","Monténégro","Maroc","Mozambique","Namibie","Nauru","Népal","Nicaragua",
    "Niger","Nigéria","Norvège","Nouvelle-Zélande","Oman","Ouganda","Ouzbékistan",
    "Pakistan","Palaos","Panama","Papouasie-Nouvelle-Guinée","Paraguay","Pays-Bas",
    "Pérou","Philippines","Pologne","Portugal","Qatar","République dominicaine",
    "Roumanie","Royaume-Uni","Russie","Rwanda","Saint-Christophe-et-Niévès",
    "Sainte-Lucie","Saint-Vincent-et-les Grenadines","Îles Salomon","Samoa",
    "Sao Tomé-et-Principe","Sénégal","Serbie","Seychelles","Sierra Leone","Singapour",
    "Slovaquie","Slovénie","Somalie","Soudan","Soudan du Sud","Sri Lanka","Suède",
    "Suisse","Suriname","Eswatini","Syrie","Tadjikistan","Tanzanie","Thaïlande",
    "Timor oriental","Togo","Tonga","Trinité-et-Tobago","Tunisie","Turkménistan",
    "Turquie","Tuvalu","Ukraine","Uruguay","Vanuatu","Vatican","Venezuela",
    "Viêt Nam","Yémen","Zambie","Zimbabwe"
  ],
  es: [
    "Afganistán","Sudáfrica","Albania","Argelia","Alemania","Andorra","Angola",
    "Antigua y Barbuda","Arabia Saudita","Argentina","Armenia","Australia","Austria",
    "Azerbaiyán","Bahamas","Baréin","Bangladesh","Barbados","Bélgica","Belice",
    "Benín","Bután","Bielorrusia","Birmania","Bolivia","Bosnia y Herzegovina",
    "Botsuana","Brasil","Brunéi","Bulgaria","Burkina Faso","Burundi","Camboya",
    "Camerún","Canadá","Cabo Verde","República Centroafricana","Chad","Chile","China",
    "Chipre","Colombia","Comoras","Congo (República)","Congo (R. D.)","Corea del Norte",
    "Corea del Sur","Costa Rica","Costa de Marfil","Croacia","Cuba","Dinamarca",
    "Yibuti","Dominica","Egipto","El Salvador","Emiratos Árabes Unidos","Ecuador",
    "Eritrea","España","Estonia","Estados Unidos","Etiopía","Fiyi","Finlandia",
    "Francia","Gabón","Gambia","Georgia","Ghana","Grecia","Granada","Guatemala",
    "Guinea","Guinea-Bisáu","Guinea Ecuatorial","Guyana","Haití","Honduras","Hungría",
    "India","Indonesia","Irak","Irán","Irlanda","Islandia","Israel","Italia","Jamaica",
    "Japón","Jordania","Kazajistán","Kenia","Kirguistán","Kiribati","Kuwait","Laos",
    "Lesoto","Letonia","Líbano","Liberia","Libia","Liechtenstein","Lituania",
    "Luxemburgo","Macedonia del Norte","Madagascar","Malasia","Malaui","Maldivas",
    "Malí","Malta","Islas Marshall","Mauritania","Mauricio","México","Micronesia",
    "Moldavia","Mónaco","Mongolia","Montenegro","Marruecos","Mozambique","Namibia",
    "Nauru","Nepal","Nicaragua","Níger","Nigeria","Noruega","Nueva Zelanda","Omán",
    "Uganda","Uzbekistán","Pakistán","Palaos","Panamá","Papúa Nueva Guinea","Paraguay",
    "Países Bajos","Perú","Filipinas","Polonia","Portugal","Catar",
    "República Dominicana","Rumanía","Reino Unido","Rusia","Ruanda",
    "San Cristóbal y Nieves","Santa Lucía","San Vicente y las Granadinas",
    "Islas Salomón","Samoa","Santo Tomé y Príncipe","Senegal","Serbia","Seychelles",
    "Sierra Leona","Singapur","Eslovaquia","Eslovenia","Somalia","Sudán",
    "Sudán del Sur","Sri Lanka","Suecia","Suiza","Surinam","Esuatini","Siria",
    "Tayikistán","Tanzania","Tailandia","Timor Oriental","Togo","Tonga",
    "Trinidad y Tobago","Túnez","Turkmenistán","Turquía","Tuvalu","Ucrania","Uruguay",
    "Vanuatu","Ciudad del Vaticano","Venezuela","Vietnam","Yemen","Zambia","Zimbabue"
  ],
  pt: ["Afeganistão","África do Sul","Albânia","Argélia","Alemanha","Andorra","Angola",
    "Antígua e Barbuda","Arábia Saudita","Argentina","Arménia","Austrália","Áustria","Azerbaijão",
    "Bahamas","Bahrein","Bangladesh","Barbados","Bélgica","Belize","Benim","Butão","Bielorrússia",
    "Myanmar","Bolívia","Bósnia e Herzegovina","Botswana","Brasil","Brunei","Bulgária","Burquina Faso",
    "Burúndi","Camboja","Camarões","Canadá","Cabo Verde","República Centro-Africana","Chade","Chile",
    "China","Chipre","Colômbia","Comores","República do Congo","República Democrática do Congo","Coreia do Norte",
    "Coreia do Sul","Costa Rica","Costa do Marfim","Croácia","Cuba","Dinamarca","Djibuti","Dominica","Egito","El Salvador",
    "Emirados Árabes Unidos","Equador","Eritreia","Espanha","Estónia","Estados Unidos","Etiópia","Fiji","Finlândia","França",
    "Gabão","Gâmbia","Geórgia","Gana","Grécia","Granada","Guatemala","Guiné","Guiné-Bissau","Guiné Equatorial","Guiana","Haiti",
    "Honduras","Hungria","Índia","Indonésia","Iraque","Irão","Irlanda","Islândia","Israel","Itália","Jamaica","Japão","Jordânia",
    "Cazaquistão","Quénia","Quirguistão","Quiribáti","Kuwait","Laos","Lesoto","Letónia","Líbano","Libéria","Líbia","Liechtenstein",
    "Lituânia","Luxemburgo","Macedónia do Norte","Madagáscar","Malásia","Malawi","Maldivas","Mali","Malta","Ilhas Marshall",
    "Mauritânia","Maurícia","México","Micronésia","Moldávia","Mónaco","Mongólia","Montenegro","Marrocos","Moçambique","Namíbia",
    "Nauru","Nepal","Nicarágua","Níger","Nigéria","Noruega","Nova Zelândia","Omã","Uganda","Uzbequistão","Paquistão","Palau",
    "Panamá","Papua Nova Guiné","Paraguai","Países Baixos","Peru","Filipinas","Polónia","Portugal","Qatar","República Dominicana",
    "Roménia","Reino Unido","Rússia","Ruanda","São Cristóvão e Neves","São Lúcia","São Vicente e Granadinas","Ilhas Salomão","Samoa",
    "São Tomé e Príncipe","Senegal","Sérvia","Seicheles","Serra Leoa","Singapura","Eslováquia","Eslovénia","Somália","Sudão",
    "Sudão do Sul","Sri Lanka","Suécia","Suíça","Suriname","Essuatíni","Síria","Tajiquistão","Tanzânia","Tailândia","Timor-Leste",
    "Togo","Tonga","Trindade e Tobago","Tunísia","Turquemenistão","Turquia","Tuvalu","Ucrânia","Uruguai","Vanuatu",
    "Cidade do Vaticano","Venezuela","Vietname","Iémen","Zâmbia","Zimbábue"]
};


// Fonction utilitaire pour obtenir la langue courante (déjà défini plus haut)
// const getCurrentLanguage = () => { ... }

function getCountries() {
  const lang = getCurrentLanguage();
  // fallback: en
  return countriesByLang[lang] || countriesByLang["en"];
}

// ======= Listes dépendantes de la langue =======
const prioritizedCountriesByLang = {
  en: ["United Kingdom", "United States"],
  fr: ["France", "Canada"],
  es: ["Colombia", "Costa Rica"],
  pt: ["Brasil", "Portugal"]
};

const titlesByLang = {
  en: ["Dr", "Prof."],
  fr: ["Dr", "Pr"],
  es: ["Dra", "Dr", "Prof."],
  pt: ["Dr.", "Prof"],
};

const titlesByLangForPADD = {
  en: ["Mr.", "Ms."],
  fr: ["M.", "Mme"],
  es: ["Sr.", "Sra."]
};

const getPrioritizedCountries = (lang = getCurrentLanguage()) =>
  (prioritizedCountriesByLang[lang] || prioritizedCountriesByLang.en).slice();

const getTitles = (lang = getCurrentLanguage(), platform = getPlatform()) =>
  (platform == "dadd") ?
  (titlesByLang[lang] || titlesByLang.en).slice() :
  (titlesByLangForPADD[lang] || titlesByLangForPADD.en).slice();

function populateCountries() {
  const select = document.getElementById('pays');
  if (!select) return;
  const allCountries = getCountries();
  const prioritizedCountries = getPrioritizedCountries();
  const sortedCountries = allCountries.slice().sort((a, b) => a.localeCompare(b, getCurrentLanguage()));
  const remainingCountries = sortedCountries.filter(c => !prioritizedCountries.includes(c));
  const finalList = [...prioritizedCountries, ...remainingCountries];
  finalList.forEach(country => {
    const option = document.createElement('option');
    option.value = country;
    option.innerText = country;
    select.appendChild(option);
  });
}
document.addEventListener('DOMContentLoaded', populateCountries);

function populateTitles() {
  const select = document.getElementById('titre');
  if (!select) return;
  const titles = getTitles();
  titles.forEach(title => {
    const option = document.createElement('option');
    option.value = title;
    option.innerText = title;
    select.appendChild(option);
  });
}
document.addEventListener('DOMContentLoaded', populateTitles);

// ======= Désactiver/Réactiver le scroll global =======
function disableScroll() {
  document.body.style.overflow = 'hidden';
}
function enableScroll() {
  document.body.style.overflow = '';
}

// ======= Fonctions d'Affichage (Loader, Popup) =======
function showLoader(show) {
  const overlay = document.getElementById('loaderOverlay');
  if (overlay) {
    overlay.style.display = show ? "flex" : "none";
  }
  if (show) {
    disableScroll();
  } else {
    enableScroll();
  }
}
function showPopup(message) {
  const popupModal = document.getElementById('popupModal');
  const popupMessage = document.getElementById('popupMessage');
  popupMessage.innerText = message;
  popupModal.style.display = "flex";
  disableScroll();
}

let closePopup = document.getElementById('closePopup');
if(closePopup){
  closePopup.addEventListener('click', () => {
    document.getElementById('popupModal').style.display = "none";
    enableScroll();
  });
}


// ======= Détection de la plateforme (dadd / padd) =======
function getPlatform() {
  const filename = window.location.pathname.split('/').pop().toLowerCase();
  if (filename.includes('padd')) return 'padd';
  return 'dadd';
}

// ======= Validation & Soumission du Formulaire (x-www-form-urlencoded) =======
const form = document.getElementById('pledgeForm');
if (form) {
  form.addEventListener('submit', (e) => {
    e.preventDefault();
    const language = getCurrentLanguage();
    const regexName = /^[A-Za-zÀ-ÖØ-öø-ÿ\s'-]+$/;
    const regexEmail = /^[\w.-]+@([\w-]+\.)+[\w-]{2,4}$/;

    const titre = document.getElementById('titre').value;
    const nom = document.getElementById('nom').value.trim();
    const prenom = document.getElementById('prenom').value.trim();
    const email = document.getElementById('email').value.trim();
    const pays = document.getElementById('pays').value;
    const sign = document.getElementById('sign').checked;
    const acceptTerms = document.getElementById('acceptTerms').checked;

    // Validation
    if (!regexName.test(nom)) { showPopup(translations[lang].invalidName); return; }
    if (titre === "") { showPopup(translations[lang].invalidTitre); return; }
    if (!regexName.test(prenom)) { showPopup(translations[lang].invalidPrenom); return; }
    if (!regexEmail.test(email)) { showPopup(translations[lang].invalidEmail); return; }
    if (pays === "") { showPopup(translations[lang].invalidPays); return; }
    if (!sign) { showPopup(translations[lang].signatureMissing); return; }
    if (!acceptTerms) { showPopup(translations[lang].invalidAcceptTerms); return; }

    showLoader(true);

    const params = new URLSearchParams();
    params.append('language', language);
    params.append('platform', getPlatform());
    params.append('titre', titre);
    params.append('nom', nom);
    params.append('prenom', prenom);
    params.append('email', email);
    params.append('pays', pays);
    params.append('signature', sign);
    params.append('acceptTerms', acceptTerms);

    console.log(params.toString());

    fetch('https://script.google.com/macros/s/AKfycbxdRrE_uaf44qXciLPDqyORWBOkafcZWeATlvvglFmgxu3-_Cwgawofl0C1F54bWcCCKw/exec', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: params.toString()
    })
    .then(response => response.json())
    .then(result => {
      showLoader(false);
      if (result.success) {
        showPopup(translations[language].successMessage);
        form.reset();
      } else {
        showPopup(translations[language].errorMessage);
      }
    })
    .catch(error => {
      console.error('Erreur:', error);
      showLoader(false);
      showPopup(translations[language].errorMessage);
    });
  });
}

  function updateCounter(localUpdate) {
     if(localUpdate){
      displayCounter();
    }
    else {
      fetch('https://script.google.com/macros/s/AKfycbxdRrE_uaf44qXciLPDqyORWBOkafcZWeATlvvglFmgxu3-_Cwgawofl0C1F54bWcCCKw/exec?method=pledgeCount')
      .then(response => response.json())
      .then(data => {
        console.log('data:', data);
        const daddCount = data.daddPledgeCount;
        const paddCount = data.paddPledgeCount;
        localStorage.setItem("daad::pledgeCount", daddCount);
        localStorage.setItem("paad::pledgeCount", paddCount);
        displayCounter();
      })
      .catch(error => {
        console.error('Error fetching counter:', error);
      });
    }    
  }

  function displayCounter(){    
    let counterContainer =  document.querySelector('.counter-container');
    let shouldAddDADDParticipants = ("true" === counterContainer.getAttribute("data-dadd"));
    let shouldAddPADDParticipants = ("true" === counterContainer.getAttribute("data-padd"));
    let daddValue = parseInt(localStorage.getItem("daad::pledgeCount")) || 0;
    let paddValue = parseInt(localStorage.getItem("paad::pledgeCount")) || 0;
    console.log("displayCounter", shouldAddDADDParticipants, shouldAddPADDParticipants, daddValue, paddValue);
    let value = 0;
    if(shouldAddDADDParticipants){
      value += daddValue;
    }
    if(shouldAddPADDParticipants){
      value += paddValue;
    }

    const countStr = String(value).padStart(4, '0');
    document.querySelector('.counter-container').classList.remove("faded");
    const symbols = document.querySelectorAll('.counter-symbol');
    symbols.forEach((elem, index) => {
      elem.innerText = countStr.charAt(index) || '';
    });
  }
  
  document.addEventListener('DOMContentLoaded', () => {
    if(null != document.querySelector('.counter-container')){
      updateCounter(true);
      updateCounter();
      setInterval(updateCounter, 30000);
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
  // Récupère les paramètres de l'URL actuelle (incluant le "?" s'ils existent)
  const currentParams = window.location.search; 
  if (!currentParams) return; // s'il n'y a pas de paramètres, rien à faire

  // Parcourt tous les liens
  document.querySelectorAll('a[href]').forEach(anchor => {
    let href = anchor.getAttribute('href');
    // Vérifie que le lien est interne (ne commence pas par http://, https:// ou //) et qu'il ne s'agit pas d'un lien ancre (#)
    if (!/^(?:[a-z]+:)?\/\//i.test(href) && href.charAt(0) !== '#') {
      // Crée une URL en se basant sur l'origine actuelle
      const url = new URL(href, window.location.origin);

      // Si l'URL du lien a déjà des paramètres, on fusionne
      const linkParams = new URLSearchParams(url.search);
      const currentSearchParams = new URLSearchParams(currentParams);
      currentSearchParams.forEach((value, key) => {
        // Remplace ou ajoute le paramètre
        linkParams.set(key, value);
      });
      // Met à jour l'URL du lien avec le nouveau search string
      url.search = linkParams.toString();

      // Met à jour l'attribut href avec le nouveau chemin complet
      anchor.setAttribute('href', url.pathname + url.search + url.hash);
    }
  });
});